import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY_NAME, P_IVA } from "@/constants/brand";

const Block = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-white mb-2.5">{title}</h2>
    <p>{children}</p>
  </section>
);

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" testid="cookie-policy-page">
      <Block title="1. Cosa sono i cookie">
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono
        memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.
      </Block>
      <Block title="2. Cookie utilizzati da questo sito">
        Questo sito, gestito da {COMPANY_NAME} (P.IVA {P_IVA}), utilizza esclusivamente cookie tecnici e strumenti
        di memorizzazione locale strettamente necessari al funzionamento dell'area riservata (gestione della
        sessione amministratore). Non vengono utilizzati cookie di profilazione o di terze parti a fini
        pubblicitari.
      </Block>
      <Block title="3. Gestione delle preferenze">
        Puoi cancellare i cookie tecnici in qualsiasi momento tramite le impostazioni del tuo browser. La loro
        disattivazione può compromettere l'accesso all'area riservata, ma non la navigazione pubblica del sito.
      </Block>
    </LegalLayout>
  );
}
